import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material';

export const BookACallDialog = ({ open, onClose }) => {
  const handleClose = () => onClose();

  return (
    <Dialog open={open} onClose={handleClose} fullWidth sx={{ maxWidth: '496px', margin: 'auto' }}>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>
        <Typography variant="body1">
          New accounts are activated after onboarding. Please book a call to complete onboarding.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          href="https://calendly.com/gurungtashi-qualz/30min?month=2025-09"
          target="_blank"
          rel="noopener noreferrer"
          variant="contained"
          color="primary"
          fullWidth
          sx={{
            transition: 'all 0.2s ease-in-out',
          }}
        >
          Book a Call
        </Button>
      </DialogActions>
    </Dialog>
  );
};
